const adminForm = {

  previewForm: [
    {
      type: 'label',
      label: 'first_name',
      class: 'col-md-3 input-form',
      placeHolder: 'name',
      name: 'Name',
      id: 'Name',
      style: {},
      required: true
    },
    {
      type: 'label',
      label: 'last_name',
      placeHolder: 'last_name',
      name: 'Lastname',
      class: 'col-md-3 input-form',
      id: 'LastName',
      style: {},
      required: true
    }, {
      type: 'label',
      label: 'email',
      class: 'col-md-3 input-form',
      placeHolder: 'email',
      name: 'Email',
      id: 'Email',
      style: {},
      required: true
    },
    {
      type: 'label',
      options: 'Role',
      label: 'job_role',
      name: 'Role',

      class: 'col-md-3 input-form',
      id: 'Role',
      style: {},
      required: true
    },
    {
      type: 'label',
      label: 'job_position',
      placeHolder: 'job_position',
      name: 'Position',
      class: 'col-md-3 input-form',
      id: 'Position',
      style: {},
      required: false
    },



    {
      type: 'label',
      label: 'phone',
      class: 'col-md-3 input-form',
      placeHolder: 'phone',
      name: 'Telephone',
      id: 'Telephone',
      style: {},
      required: false
    },

    {
      type: 'lang',
      label: 'language',
      class: 'col-md-3 input-form',
      placeHolder: 'language',
      name: 'Language',
      id: 'idSystemLanguages',
      style: {},
      required: false
    }



    // {
    //   type: 'Input',
    //   label: 'Confirm Password',
    //   class: 'col-md-4 input-form',
    //   placeHolder: '',
    //   name: 'ConfirmPassword',
    //   id: 'ConfirmPassword',
    //   datatype: 'Password',
    //   style: {},
    //   required: true
    // }
  ],
  editInfo: [
    {
      type: 'input',
      label: 'first_name',
      class: 'col-md-3 input-form',
      placeHolder: 'name',
      name: 'Name',
      id: 'Name',
      style: {},
      required: true
    },
    {
      type: 'input',
      label: 'last_name',
      placeHolder: 'last_name',
      name: 'Lastname',
      class: 'col-md-3 input-form',
      id: 'LastName',
      style: {},
      required: true
    }, {
      type: 'label',
      label: 'email',
      class: 'col-md-3 input-form',
      placeHolder: 'email',
      name: 'Email',
      id: 'Email',
      style: {},
      required: false
    },
    {
      type: 'label',
      options: 'Role',
      label: 'job_role',
      name: 'Role',

      class: 'col-md-3 input-form',
      id: 'Role',
      style: {},
      required: false
    },
    {
      type: 'input',
      label: 'job_position',
      placeHolder: 'job_position',
      name: 'Position',
      class: 'col-md-3 input-form',
      id: 'Position',
      style: {},
      required: false
    },



    {
      type: 'input',
      label: 'phone',
      class: 'col-md-3 input-form',
      placeHolder: 'phone',
      name: 'Telephone',
      id: 'Telephone',
      style: {},
      required: false
    },

    {
      type: 'select',
      label: 'language',
      class: 'col-md-3 input-form',
      placeHolder: 'language',
      name: 'idSystemLanguages',
      id: 'idSystemLanguages',
      style: {},
      required: true
    },
    {
      type: 'empty',
      class: 'col-md-3 input-form',
    },
    {
      type: 'input',
      label: 'change_password',
      class: 'col-md-3 input-form',
      placeHolder: '',
      name: 'Password',
      id: 'Password',
      datatype: 'Password',
      style: {},
      required: false
    },

    {
      type: 'input',
      label: 'confirm_pass',
      class: 'col-md-3 input-form',
      placeHolder: '',
      name: 'ConfirmPassword',
      id: 'ConfirmPassword',
      datatype: 'Password',
      style: {},
      required: false
    }
    // {
    //   type: 'Input',
    //   label: 'Confirm Password',
    //   class: 'col-md-4 input-form',
    //   placeHolder: '',
    //   name: 'ConfirmPassword',
    //   id: 'ConfirmPassword',
    //   datatype: 'Password',
    //   style: {},
    //   required: true
    // }
  ],
  entity: [
    {
      type: 'label',
      label: 'name',
      class: 'col-md-3 input-form',
      placeHolder: 'name',
      name: 'Nombre',
      id: 'Nombre',
      style: {},
      required: true
    },
    {
      type: 'label',
      label: 'address',
      placeHolder: 'address',
      name: 'Address',
      class: 'col-md-3 input-form',
      id: 'Address',
      style: {},
      required: true
    }, {
      type: 'label',
      label: 'city',
      class: 'col-md-3 input-form',
      placeHolder: 'City',
      name: 'City',
      id: 'City',
      style: {},
      required: true
    },
    {
      type: 'label',
      label: 'state',
      name: 'State',

      class: 'col-md-3 input-form',
      id: 'State',
      style: {},
      required: true
    },



    {
      type: 'label',
      label: 'phone',
      class: 'col-md-3 input-form',
      placeHolder: 'phone',
      name: 'Telephone',
      id: 'Telephone',
      style: {},
      required: false
    }
    ,
    {
      type: 'label',
      label: 'country',
      placeHolder: 'country',
      name: 'CountryCode',
      class: 'col-md-3 input-form',
      id: 'CountryCode',
      style: {},
      required: false
    },
    {
      type: 'label',
      label: 'Owner_Team',
      placeHolder: 'Owner_Team',
      name: 'OwnerTeam',
      class: 'col-md-3 input-form',
      id: 'OwnerTeam',
      style: {},
      required: false,
      validateRole: true
    },
    {
      type: 'label',
      label: 'AccountID_SAP',
      placeHolder: 'AccountID_SAP',
      name: 'AccountIDSAP',
      class: 'col-md-3 input-form',
      id: 'AccountIDSAP',
      style: {},
      required: false,
      validateRole: true

    },
    {
      type: 'label',
      label: 'Account_Status',
      placeHolder: 'Account_Status',
      name: 'AccountStatus',
      class: 'col-md-3 input-form',
      id: 'AccountStatus',
      style: {},
      required: false,
      validateRole: true

    }
    // {
    //   type: 'Input',
    //   label: 'Confirm Password',
    //   class: 'col-md-4 input-form',
    //   placeHolder: '',
    //   name: 'ConfirmPassword',
    //   id: 'ConfirmPassword',
    //   datatype: 'Password',
    //   style: {},
    //   required: true
    // }
  ]

}
export default adminForm